import { Component, Input, ViewEncapsulation } from '@angular/core';
import * as shape from 'd3-shape';

@Component({
  selector: 'area-chart',
  template: `
    <div class="h-80" fxFlex>
      <ngx-charts-area-chart
        *fuseIfOnDom
        [results]="results"
        [scheme]="conf.scheme"
        [gradient]="conf.gradient"
        [xAxis]="conf.xAxis"
        [yAxis]="conf.yAxis"
        [legend]="conf.legend"
        [showXAxisLabel]="conf.showXAxisLabel"
        [showYAxisLabel]="conf.showYAxisLabel"
        [xAxisLabel]="conf.xAxisLabel"
        [yAxisLabel]="conf.yAxisLabel"
        [curve]="conf.curve">
      </ngx-charts-area-chart>
    </div>
  `,
  styles: [`
    area-chart g.area-chart.chart {
      transform: translate(0, 10px);
      border-bottom: thin solid #42BFF7;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class AreaChartComponent {
  @Input() results: any;

  public conf = {
    xAxis         : false,
    yAxis         : false,
    gradient      : false,
    legend        : false,
    showXAxisLabel: false,
    xAxisLabel    : 'Days',
    showYAxisLabel: false,
    yAxisLabel    : 'Issues',
    scheme        : {
      domain: ['#0055ff']
    },
    curve         : shape.curveBasis
  };

}
